export default {
  routes: [
    {
      path: '/',
      redirect: '/project'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../admin/page/login/login')
    }, {
      path: '/register',
      name: 'register',
      component: () => import('../admin/page/login/register')
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('../admin/page/project/layout'),
      children: [
        {
          path: '',
          component: () => import('../admin/page/project/index')
        },
        {
          path: 'profile',
          component: () => import('../admin/page/user/profile')
        },
        {
          path: 'resetPassword',
          component: () => import('../admin/page/user/resetPassword')
        },
        {
          path: 'machine/detail',
          component: () => import('../admin/page/project/detail')
        },
        {
          path: ':className',
          component: () => import('../admin/page/project/classes')
        }, {
          path: ':className/edit/:id',
          component: () => import('../admin/page/project/edit')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/admin.js